// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"203":"c8a144c7","492":"114df3a8","635":"458165c5","825":"8e92b88e","905":"95df98a2"}[chunkId] + ".chunk.css";
};